import { Component, Input } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { GraphDescription } from 'src/app/services/sanity/sanity.types';

@Component({
  selector: 'app-graphtext',
  templateUrl: './graphtext.component.html',
  styleUrls: ['./graphtext.component.scss']
})
export class GraphtextComponent {
  @Input() showNoAnlegg: boolean;
  @Input() activeGraphDescription: GraphDescription;

  constructor(private alertController: AlertController) {}

  async openAlert() {
    const alert = await this.alertController.create({
      header: this.activeGraphDescription.title,
      message: this.activeGraphDescription.description,
      cssClass: 'push-alert whitespace-pre-line break-spaces',
      mode: 'ios',
      backdropDismiss: true,
      buttons: ['Lukk']
    });
    await alert.present();
  }
}
